"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createDeprecatedMintPrintingTokensInstruction = exports.deprecatedMintPrintingTokensInstructionDiscriminator = exports.DeprecatedMintPrintingTokensStruct = void 0;
const splToken = __importStar(require("@solana/spl-token"));
const beet = __importStar(require("@metaplex-foundation/beet"));
const web3 = __importStar(require("@solana/web3.js"));
const MintPrintingTokensViaTokenArgs_1 = require("../types/MintPrintingTokensViaTokenArgs");
exports.DeprecatedMintPrintingTokensStruct = new beet.BeetArgsStruct([
    ['instructionDiscriminator', beet.u8],
    ['mintPrintingTokensViaTokenArgs', MintPrintingTokensViaTokenArgs_1.mintPrintingTokensViaTokenArgsBeet],
], 'DeprecatedMintPrintingTokensInstructionArgs');
exports.deprecatedMintPrintingTokensInstructionDiscriminator = 9;
function createDeprecatedMintPrintingTokensInstruction(accounts, args, programId = new web3.PublicKey('metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s')) {
    var _a, _b;
    const [data] = exports.DeprecatedMintPrintingTokensStruct.serialize({
        instructionDiscriminator: exports.deprecatedMintPrintingTokensInstructionDiscriminator,
        ...args,
    });
    const keys = [
        {
            pubkey: accounts.destination,
            isWritable: true,
            isSigner: false,
        },
        {
            pubkey: accounts.printingMint,
            isWritable: true,
            isSigner: false,
        },
        {
            pubkey: accounts.updateAuthority,
            isWritable: false,
            isSigner: true,
        },
        {
            pubkey: accounts.metadata,
            isWritable: false,
            isSigner: false,
        },
        {
            pubkey: accounts.masterEdition,
            isWritable: false,
            isSigner: false,
        },
        {
            pubkey: (_a = accounts.tokenProgram) !== null && _a !== void 0 ? _a : splToken.TOKEN_PROGRAM_ID,
            isWritable: false,
            isSigner: false,
        },
        {
            pubkey: (_b = accounts.rent) !== null && _b !== void 0 ? _b : web3.SYSVAR_RENT_PUBKEY,
            isWritable: false,
            isSigner: false,
        },
    ];
    const ix = new web3.TransactionInstruction({
        programId,
        keys,
        data,
    });
    return ix;
}
exports.createDeprecatedMintPrintingTokensInstruction = createDeprecatedMintPrintingTokensInstruction;
//# sourceMappingURL=DeprecatedMintPrintingTokens.js.map